import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {
    useModalsReportTicketRate
} from "@dropDesk/presentation/pages/reports/report_ticket_aggs_init/report_ticket_rate_aggregate/ui/modals/handle_change_visible";


const ModalsReportTicketRate = observer(
    ({
     }: {
     }
    ) => {

        const {
            visibleModalSearchUser, setVisibleModalSearchUser,
        } = useBetween(useModalsReportTicketRate);


        return (
            <>

            </>
        )
    })
export default ModalsReportTicketRate;
